import { render, staticRenderFns } from "./BulkDelete.vue?vue&type=template&id=1f0a545e"
import script from "./BulkDelete.vue?vue&type=script&lang=js"
export * from "./BulkDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports